export { default } from "./LuggageTagText";
